import React, { useState,useEffect } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from '@mui/material';
import moment from 'moment/moment';
import QRCode from 'react-qr-code';  
import { useApi } from '../ContextApi/ContextApi';
import { readFontStyle } from './fontStyle';
import '../UI/Template.css';

const Template1 = ({ reportData,QRurl }) => {
    const [FontStyle,setFontStyles] = useState({});
    const [DRS,setDRS] = useState([]);
  const currentDateTime = new Date();
  // const formattedCurrentDate = moment(currentDateTime).format('D MMM YYYY | HH:mm:ss');
  const username = sessionStorage.getItem("FirstName") + sessionStorage.getItem("LastName");
const { Comment,isheader } = useApi();
  const groupByCategoryAndSubCategory = (data) => {
    return data.reduce((result, item) => {
      const category = item.categorY_CODE;
      const subCategory = item.suB_CATEGORY_CODE;

      if (!result[category]) {
        result[category] = {
          categoryValue: item.categorY_VALUE,
          subCategories: {},
        };
      }

      if (!result[category].subCategories[subCategory]) {
        result[category].subCategories[subCategory] = {
          subCategoryValue: item.suB_CATEGORY_VALUE,
          items: [],
        };
      }

      result[category].subCategories[subCategory].items.push(item);
      return result;
    }, {});
  };
   useEffect(()=>{
       setFontStyles(readFontStyle())
   },[])
    
  const groupedData = groupByCategoryAndSubCategory(reportData);

  // Function to format normal range and unit values
  const formatTextWithLineBreaks = (text) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  //getting image from loacal storage
  const image = localStorage.getItem('LogoImage');

  const LabName = reportData.find((x) => x.laboratoryName != '' && x.laboratoryName != null)?.laboratoryName;
  const qrCodeValue = QRurl ;
  return (
    <>
      <div>
       {isheader ?
        <div style={{ width: '100%', marginBottom: '20px' }}>
          <img className="logo" src={"data:image/png;base64," + image} alt="Lab Logo" style={{ width: '100%', height: '130px' , objectFit: 'contain'}} />
        </div>
        :''} 
        <div style={{ padding: '1rem', fontFamily:FontStyle?.fontfamily? FontStyle?.fontfamily :"sans-serif", fontSize:FontStyle?.fontsize? FontStyle?.fontsize :'10px', fontWeight:FontStyle?.fontweight || 'normal' }}>
          <Grid container spacing={8}  className='P-Info-1'>
            <Grid item xs={6}>
              <div style={{ textAlign: 'start' }}>
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                 <QRCode value={qrCodeValue} size={100} />
                 <p style={{ fontSize: FontStyle?.fontsize || '12px' }}>Scan to Download</p>
              </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ float: 'right' }}>
                <div style={{ textAlign: 'end' }}>
                  <span className='Template3_Patient_Info'>Mr No:&nbsp;{reportData?.[0]?.patientID}-{sessionStorage.getItem('LabID')}</span>
                </div>
                <div style={{ textAlign: 'end' }}>
                  <span className='Template3_Patient_Info'>Patient Name:&nbsp;{reportData?.[0]?.patientName}</span>
                </div>
                <div style={{ textAlign: 'end' }}>
                  <span className='Template3_Patient_Info'>Age|Gender:&nbsp;{reportData?.[0]?.age}Years|{reportData?.[0]?.sex}</span>
                </div>
                <div style={{ textAlign: 'end' }}>
                  <span className='Template3_Patient_Info'>Phone Number:&nbsp;{reportData?.[0]?.contactNumber}</span>
                </div>
                <div style={{ textAlign: 'end' }}>
                  <span className='Template3_Patient_Info'>Referred by:&nbsp;{reportData?.[0]?.referredBy}</span>
                </div>
              </div>
            </Grid>
          </Grid>
          <div>
            <span style={{ fontSize: '10px' }}>Reported At: {moment(reportData?.[0]?.createdAt).format('D MMM YYYY | HH:mm:ss')}</span>
          </div>

          {/* Table Section */}
          {Object.keys(groupedData).map((category, index) => (
            <div key={index}>
               <div style={{border:'1px solid lightgray'}}>
                  <p style={{ textAlign: 'center', marginTop: '10px', fontWeight: FontStyle?.fontweight || 600 }}>{groupedData[category].categoryValue}</p>
               </div> 
              {Object.keys(groupedData[category].subCategories).map((subCategory, subIndex) => (
                <div key={subIndex}>
                  <span style={{ textAlign: 'left', fontWeight: FontStyle?.fontweight || 600 }}>{groupedData[category].subCategories[subCategory].subCategoryValue}</span>
                  <table style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Test Description</th>
                        <th>Result</th>
                        <th>Unit</th>
                        <th>Normal Range</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedData[category].subCategories[subCategory].items.map((data, index) => (
                        <React.Fragment key={index}>
                        <tr>
                          <td>{data.testName}</td>
                          <td style={{ fontWeight: 'bold' }}>{data.testResult}</td>
                          <td>{formatTextWithLineBreaks(data.unit)}</td>
                          <td>{formatTextWithLineBreaks(data.normalRange)}</td>
                        </tr>
                        {data.comment && data.comment.trim() !== '' && (
                          <tr>
                            <td colSpan={4} style={{ paddingLeft: '20px', fontStyle: 'italic' }}>
                             comment: {data.comment}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                       
                      ))}
                    </tbody>
                  </table>
                  {/* <hr /> */}
                </div>
              ))}
            </div>
          ))}
          <hr></hr>
          <div>
              <span>Report Comment</span>
              <div style={{border:'1px solid lightgray'}}>
                    <p>{Comment}</p>
              </div>
          </div>
          <div className='d-flex justify-content-between' style={{ fontSize: '10px' }}>
            <span>
                <span>Printed at:  {moment(currentDateTime).format('DD-MMM-YYYY hh:mm A')}</span> &nbsp; <span>Printed By: {username}</span>
            </span>
          </div>
        </div>
      </div>
      <footer>
      <p>&copy; {new Date().getFullYear()} {LabName}. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Template1;
